/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as TYPES from './action-types';
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { dispatchCheckSearchValues } from '../../../Maintain/Check/store/actions';

export const setDisplayCheckSuccessMessage = (payload) => {
  return {
    type: TYPES.DISPLAY_CHECK_SUCCESS_MESSAGE,
    payload,
  };
};

export const setDisplayCheckErrorMessage = (payload) => {
  return {
    type: TYPES.DISPLAY_CHECK_ERROR_POPUP_MESSAGE,
    payload,
  };
};

export const setDisplayCheckLoading = (payload) => {
  return {
    type: TYPES.DISPLAY_CHECK_LOADING,
    payload,
  };
};

export const setIsSearchCheckFromDisplay = (payload) => {
  return {
    type: TYPES.SEARCH_CHECK_FROM_DISPLAY,
    payload,
  };
};

export const setDisplayCheckTableData = (payload) => {
  return {
    type: TYPES.DISPLAY_CHECK_TABLE_DATA,
    payload,
  };
};

export const setDisplayCheckReferenceData = (payload) => {
  return {
    type: TYPES.DISPLAY_CHECK_REFERNCE_DATA,
    payload,
  };
};
export const setDisplayCheckSystemParameter = (payload) => {
  return {
    type: TYPES.DISPLAY_CHECK_SYSTEM_PARAMETER,
    payload,
  };
};

export const getgeneralsystemparameterDetails = (values) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_GENERAL_SYSTEM_PARAMETER, values)
    .then((response) => {
      dispatch(
        setDisplayCheckSystemParameter(
          (response && response.data && response.data.data) || null
        )
      );
    })
    .catch(() => {
      dispatch(setDisplayCheckSystemParameter(null));
    });
};

export const getReferenceList = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_DROPDOWN}`, values)
    .then((response) => {
      return dispatch(setDisplayCheckReferenceData(response.data));
    })
    .catch((response) => {
      dispatch(setDisplayCheckReferenceData(null));
    });
};
export const setClickOnMaintainCheckVal = (payload) => {
  return {
    type: TYPES.CLICK_ON_MAINTAIN_CHECK,
    payload,
  };
};
export const clearReduxDisplayCheckDetailScreen = () => (dispatch) => {
  dispatch(dispatchCheckSearchValues([]));
  dispatch(setDisplayCheckTableData([]));
  dispatch(setDisplayCheckReferenceData(null));
  dispatch(setDisplayCheckSystemParameter(null));
};
